<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6" v-if="!userInfo.thirdAccount && !hiddenQueryItems.includes('corpId')">
            <a-form-item label="企业">
              <j-dict-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.wf_consumer_corp,corp_name,id"
                placeholder="请选择企业"
                v-model="queryParam.corpId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6" v-if=" userInfo.thirdAccount ">
            <a-form-item label="班组">
              <j-search-select-tag
                :dictOptions="consGroupOptions"
                @change="searchQuery"
                placeholder="请选择班组"
                v-model="queryParam.groupId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="车牌">
              <a-input placeholder="请输入车牌" v-debounce="searchQuery" v-model="queryParam.vehiclePlate"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="8" :md="8" :sm="24" :xl="8">
            <a-form-item label="状态">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="dev_life_status"
                placeholder="请选择更新方式"
                type="checkbox"
                v-model="queryParam.vehicleStatus"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="4" :md="4" :sm="24" :xl="4">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary" v-if=" userInfo.thirdAccount ">新增</a-button>
      <a-button @click="handleExportXls('企业车辆')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
        v-if=" userInfo.thirdAccount "
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <wf-corp-vehicle-modal @ok="modalFormOk" ref="modalForm"></wf-corp-vehicle-modal>
  </a-card>
</template>

<script>
  import { getAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WfCorpVehicleModal from './modules/WfCorpVehicleModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'WfCorpVehicleList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfCorpVehicleModal
    },
    props: {
      //表单禁用
      filter: {
        type: Object,
        default: () => { },
      }
    },
    data () {
      return {
        description: '企业车辆管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '企业',
            align: "center",
            sorter: true,
            dataIndex: 'corpId_dictText'
          },
          {
            title: '班组',
            align: "center",
            sorter: true,
            dataIndex: 'groupId_dictText'
          },
          //   {
          //     title:'人员',
          //     align:"center",
          //     sorter: true,
          //     dataIndex: 'corpUserId_dictText'
          //   },
          //   {
          //     title: '车辆类型',
          //     align: "center",
          //     sorter: true,
          //     dataIndex: 'vehicleType_dictText'
          //   },
          {
            title: '最大容量(m³)',
            align: "center",
            sorter: true,
            dataIndex: 'capacity'
          },
          {
            title: '车辆型号',
            align: "center",
            sorter: true,
            dataIndex: 'vehicleModel'
          },
          {
            title: '车牌',
            align: "center",
            sorter: true,
            dataIndex: 'vehiclePlate'
          },
          {
            title: '来源',
            align: "center",
            sorter: true,
            dataIndex: 'ownerType_dictText'
          },
          {
            title: '所属单位',
            align: "center",
            dataIndex: 'ownerOrg'
          },
          {
            title: '照片',
            align: "center",
            dataIndex: 'pictures',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '状态',
            align: "center",
            sorter: true,
            dataIndex: 'vehicleStatus_dictText'
          },
          {
            title: '备注',
            align: "center",
            dataIndex: 'remark'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/wf/corpVehicle/list",
          delete: "/wf/corpVehicle/delete",
          deleteBatch: "/wf/corpVehicle/deleteBatch",
          exportXlsUrl: "/wf/corpVehicle/exportXls",
          importExcelUrl: "wf/corpVehicle/importExcel",
          corpGroupList: 'wf/corpGroup/list',
        },
        localFilter: {},
        dictOptions: {},
        consGroupOptions: [],
        superFieldList: [],
        disableMixinCreated: true,
      }
    },
    created () {
      this.getSuperFieldList();

      //如果是企业管理员登录，赋值corpId, 值为userInfo.corpIds
      if (!!this.userInfo.thirdAccount) {
        this.localFilter = {
          corpId: this.userInfo.corpIds
        }
      } else {
        this.columns = this.columns.filter(col => col.dataIndex !== 'action')
      }

      if (this.filter?.corpId || this.localFilter?.corpId) {
        this.columns = this.columns.filter(col => col.dataIndex !== 'corpId_dictText')
        //写入queryParam，查询和导出都增加过滤条件
        this.queryParam.corpId = this.queryParam.corpId = this.filter?.corpId || this.localFilter?.corpId;
      }

      // 在 localFilter 设置完成后调用 loadData
      this.$nextTick(() => {
        this.loadData(1);
      });

      this.getConsGroup();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      hiddenQueryItems () {
        return this.filter ? Object.keys(this.filter) : [];
      },
      userInfo () {
        return this.$store.getters.userInfo
      }
    },
    methods: {
      loadData (arg) {
        if (!this.url.list) {
          this.$message.error('请设置url.list属性!')
          return
        }
        // 加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1
        }
        var params = this.getQueryParams()// 查询条件
        this.loading = true;
        // 合并 localFilter 和 filter
        const mergedFilter = { ...this.localFilter, ...this.filter };
        Object.assign(params, mergedFilter);
        if (params.vehiclePlate) {
          params.vehiclePlate = `*${params.vehiclePlate}*`
        }

        console.log('loadData params:', params); // 添加日志以检查参数
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records || res.result
            if (res.result.total) {
              this.ipagination.total = res.result.total
            } else {
              this.ipagination.total = 0
            }
          }
        }).finally(() => {
          this.loading = false
        })
      },
      handleAdd () {
        const model = {};
        if (this.filter?.corpId || this.localFilter?.corpId) {
          //写入queryParam，查询和导出都增加过滤条件
          model.corpId = this.filter?.corpId || this.localFilter?.corpId;
        }
        this.$refs.modalForm.add(model)
        this.$refs.modalForm.title = `新增`
        this.$refs.modalForm.disableSubmit = false
      },
      getConsGroup () {
        if (!this.userInfo.thirdAccount) {
          return;
        }
        this.consGroupOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          column: 'groupName',
          order: 'asc',
        };
        getAction(this.url.corpGroupList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(group => {
              this.consGroupOptions.push({
                value: group.id,
                text: group.groupName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      getConsUser () {
        if (!this.userInfo.thirdAccount) {
          return;
        }
        this.consUserOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.queryParam.corpId,
          groupId: this.queryParam.groupId,
          column: 'username',
          order: 'asc',
        };
        getAction(this.url.corpUserList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(user => {
              this.consUserOptions.push({
                value: user.id,
                text: user.nickname
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'corpId', text: '企业', dictCode: '`iwt-wf`.wf_consumer_corp,corp_name,id' })
        fieldList.push({ type: 'string', value: 'groupId', text: '班组', dictCode: '`iwt-wf`.wf_consumer_corp_group,group_name,id' })
        fieldList.push({ type: 'string', value: 'corpUserId', text: '人员', dictCode: '`iwt-wf`.wf_consumer_user,nickname,id' })
        fieldList.push({ type: 'string', value: 'vehicleType', text: '车辆类型', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'capacity', text: '最大容量(m³)', dictCode: '' })
        fieldList.push({ type: 'string', value: 'vehicleModel', text: '车辆型号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'vehiclePlate', text: '车牌', dictCode: '' })
        fieldList.push({ type: 'string', value: 'pictures', text: '照片', dictCode: '' })
        fieldList.push({ type: 'string', value: 'vehicleStatus', text: '状态', dictCode: 'dev_life_status' })
        fieldList.push({ type: 'string', value: 'remark', text: '备注', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>